import { render, staticRenderFns } from "./PendenciesExport.vue?vue&type=template&id=345b1074&scoped=true"
import script from "./PendenciesExport.vue?vue&type=script&lang=js"
export * from "./PendenciesExport.vue?vue&type=script&lang=js"
import style0 from "./PendenciesExport.vue?vue&type=style&index=0&id=345b1074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b1074",
  null
  
)

export default component.exports